import { RightOutlined } from '@ant-design/icons';
import { Space } from 'antd';
import clsx from 'clsx';
import * as React from 'react';
import { memo } from 'react';
import { NoContentArticle, Tag } from '../knowledge-base.type';
import TagIcon from '../../knowledge-base-common/components/tag-icon';

interface TagViewProps {
    tag: Tag;
    articles: NoContentArticle[];
    setActiveArticle: (article: NoContentArticle) => void;
}

const TagView = memo(({ articles, tag, setActiveArticle }: TagViewProps) => {
    return (
        <Space
            direction="vertical"
            size={16}
            style={{ display: 'flex' }}
        >
            <Space
                size={32}
                align="center"
                style={{ minHeight: 70 }}
            >
                <TagIcon
                    name={tag.icon}
                    size={45}
                />
                <p className="title">{tag.title}</p>
            </Space>
            <Space
                direction="vertical"
                size={16}
                style={{ display: 'flex' }}
            >
                {articles.map((article) => (
                    <button
                        className={clsx(
                            'button-card',
                            'button-card__article',
                            'button-card__active'
                        )}
                        key={article.id}
                        onClick={() => setActiveArticle(article)}
                    >
                        {article.title}
                        <RightOutlined />
                    </button>
                ))}
            </Space>
        </Space>
    );
});

export default TagView;
